import React from 'react';

import './EditPanel.css';

const EditPanel = ({ children }: { children: React.ReactNode }) => <section className="EditPanel">{children}</section>;

export default EditPanel;
